import { useCallback } from 'react';
import { depositFunds } from '@/unified-modules/wallet/wallet-library';
import getBalanceData from './get-balance-data';
import useEventManagerEmitter from '@/event-manager/use-event-manager-emiter';
import { GAME_WINDOW_TO_CLIENT_EVENTS } from '@/event-manager/types';
import { setGameWindowContext } from '@/store/actions.ts';

export const useDepositFundsAndReloadBalance = () => {
  const { emitClientEvent } = useEventManagerEmitter();
  const reloadBalance = useCallback(
    (balance) => {
      emitClientEvent(GAME_WINDOW_TO_CLIENT_EVENTS.RELOAD_BALANCE, balance);
    },
    [emitClientEvent],
  );

  return useCallback(async () => {
    await depositFunds();

    await getBalanceData((balance: number | null) => {
      setGameWindowContext({ balance });
      reloadBalance(balance as unknown as string);
    });
  }, [reloadBalance]);
};

export default useDepositFundsAndReloadBalance;
